let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fXQFW")).then(() => parcelRequire('5XkG4'));